import { render, staticRenderFns } from "./NewEditDocumentosPlanosPage.vue?vue&type=template&id=716e25a0&scoped=true"
import script from "./NewEditDocumentosPlanosPage.vue?vue&type=script&lang=js"
export * from "./NewEditDocumentosPlanosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e25a0",
  null
  
)

export default component.exports